/**
 * Waar een aanbieder zijn antwoord maakt. L1 van blok L, Frank 19 oktober 2026.
 *
 * De waarden zijn besloten door Frank en niet afgeleid: Ollama draait op deze Mac,
 * EuGPT in de EU, en Anthropic, OpenAI, Gemini, Deepseek, Groq en OpenRouter buiten
 * de EU. "Buiten de EU" zegt bewust niet welk land; dat is per aanbieder niet
 * vastgesteld en wordt hier dus ook niet beweerd.
 *
 * Een aanbieder die hier niet staat is ONBEKEND en nooit EU of lokaal. Een stille
 * terugval naar de gunstigste plek zou precies de belofte breken die deze tabel
 * moet waarmaken. Een wachter eist dat elke aanbieder uit PROVIDERS hier staat.
 */

export const LOKAAL = "lokaal";
export const EU = "eu";
export const BUITEN_EU = "buiten_eu";
export const ONBEKEND = "onbekend";

const LOCATIE = {
  ollama: LOKAAL,
  eugpt: EU,
  anthropic: BUITEN_EU,
  openai: BUITEN_EU,
  gemini: BUITEN_EU,
  deepseek: BUITEN_EU,
  groq: BUITEN_EU,
  openrouter: BUITEN_EU,
};

/** De Nederlandse tekst per plek; het scherm vertaalt hem met t(). */
export const LOCATIE_TEKST = {
  [LOKAAL]: "Op deze Mac",
  [EU]: "EU",
  [BUITEN_EU]: "Buiten de EU",
  [ONBEKEND]: "Locatie onbekend",
};

const VOLGORDE = [LOKAAL, EU, BUITEN_EU, ONBEKEND];

/** De aanbieder waarvan Frank zelf de plek zet (CC3, 24 oktober 2026). */
export const EIGEN = "eigen";

/**
 * De plek van een aanbieder, of ONBEKEND. PUUR. Voor de eigen aanbieder is dat de plek die
 * Frank heeft gezet (`eigenLocatie`), en zolang hij niets heeft gezet ONBEKEND.
 */
export function locatieVan(provider, eigenLocatie = "") {
  if (provider === EIGEN) return [EU, BUITEN_EU].includes(eigenLocatie) ? eigenLocatie : ONBEKEND;
  return Object.prototype.hasOwnProperty.call(LOCATIE, provider) ? LOCATIE[provider] : ONBEKEND;
}

/**
 * De aanbieders per plek, in de volgorde lokaal, EU, buiten de EU, onbekend; lege
 * groepen vallen weg. `aanbieders` is een object zoals PROVIDERS. PUUR.
 */
export function gegroepeerd(aanbieders, eigenLocatie = "") {
  return VOLGORDE
    .map((plek) => ({
      plek,
      tekst: LOCATIE_TEKST[plek],
      items: Object.entries(aanbieders).filter(([key]) => locatieVan(key, eigenLocatie) === plek),
    }))
    .filter((groep) => groep.items.length > 0);
}
